import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MainMenuButton, MetrovacesaEligeTuLook, MetrovacesaLogoShort } from '../../shared/svg/components';
import { changeIsMainMenuOpened, changeIsSummaryOpened } from '../../model/configuratorSlice';
import IsNullOrUndefined from '../../utils/ObjectUtils';

const Header = () => {
  const { settings, currentUnit } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  const openMenu = () => {
    dispatch(changeIsMainMenuOpened(true));
    dispatch(changeIsSummaryOpened(false));
  };

  return (
    <div className="header-container">
      <div className="logo-container">
        <div className="logo"><MetrovacesaEligeTuLook /></div>
        <div className="logo-mobile"><MetrovacesaLogoShort /></div>
      </div>
      <div className={`container-client-promotion${settings.name.length > 23 ? ' long-name' : ''}`}>
        <div className="promotion">{settings.name}</div>
        <div className="expiry-date">Fecha límite: {settings.promotion_end_date}</div>
      </div>
      <div className="main-title">
        {settings.projectName}
      </div>
      <button className="menu-button" type="button" onClick={() => openMenu()}>
        <MainMenuButton className="icon" />
      </button>
      <div className="container-logo-flat-name">
        {!IsNullOrUndefined(currentUnit) ? <div className="flat-name">{currentUnit.name}</div> : null}
      </div>
    </div>
  );
};

export default Header;
